module.exports = __webpack_public_path__ + "img/delivery.c4d59ab0.webp";